import PurchaseOrder from "../PurchaseOrder";

describe("PurchaseOrder model", () => {
  it("has tableName", () => {
    expect(PurchaseOrder.tableName).toBeDefined();
  });
});
